import { createLocale } from "./createLocale";

export const lt = createLocale({
  header: {
    title: "Ženkite į pasaulį. 2 $ už Short. Bet kuri kalba!",
    subtitle: "🔥Mokėkite tik už rezultatą – nuo $0.089 iki $0.009 už sekundę🔥",
  },
  steps: {
    uploadVideo: "Įkelti vaizdo įrašą",
    selectLanguages: "Pasirinkti kalbas",
    conversionResult: "Konvertavimas ir rezultatas",
  },
  upload: {
    dragAndDrop: "Nuvilkite savo vaizdo failą čia",
    orClickToSelect: "arba spustelėkite, kad pasirinktumėte",
    supportedFormats: "Palaikomi formatai: MP4, AVI, MOV, MKV, WebM",
    maxFileSize: "• Maksimalus failo dydis: 200 MB",
    maxDuration: "• Maksimali trukmė: 30 sek",
    chooseFile: "Pasirinkti failą",
    selectedFile: "Pasirinktas failas:",
    size: "Dydis:",
    fileTypeError: "Pasirinkite vaizdo failą",
    fileSizeError: "Failo dydis ({size} MB) viršija maksimalų 200 MB limitą",
    durationError: "Vaizdo įrašo trukmė ({duration} sek) viršija maksimalų 30 sek limitą",
    fileReadError: "Nepavyko nuskaityti vaizdo failo. Pabandykite kitą failą.",
  },
  languages: {
    sourceAudioLanguage: "Šaltinio garso kalba",
    targetAudioLanguage: "Tikslinio garso kalba",
    selectLanguage: "Pasirinkite kalbą...",
  },
  conversion: {
    replaceAudio: "Klonuoti mano balsą",
    uploadVideoAndSelectLanguages: "Įkelkite vaizdo įrašą ir pasirinkite kalbas, kad tęstumėte",
  },
  nav: {
    blog: "Tinklaraštis",
  },
  footer: {
    privacyPolicy: "Privatumo politika",
    termsOfUse: "Naudojimo sąlygos",
  },
  languageOptions: {
    lt: "Lietuvių",
  },
});
